<div class="container-fluid cont-ourservices pt-5">
  <div class="row pb-5">
    <div class="col-12">
      <div class="container mt-5">
        <div class="text-center pb-3">
          <h2><span class="title-blue font-size-32"> Servicios para un viaje inolvidable</span></h2>
        </div>
        <p class="info-service text-center">
          Viaja con total tranquilidad. Nuestros <b>planes</b> te brindan cobertura médica, jurídica, tecnológica y más, en más de 5.000 destinos en el mundo.
        </p>
      </div>
    </div>
    <div class="col-12 cont-carousel pb-5">
      <div class="carousel">
        <p-carousel
          id="our-services"
          [value]="services"
          [numVisible]="3"
          [numScroll]="1"
          [circular]="true"
          [responsiveOptions]="responsiveOptions"
          [autoplayInterval]="5000"
          [showIndicators]="false"
        >
          <ng-template let-service pTemplate="item">
            <div class="col-md-12 justify-content-center d-flex mt-4 mb-4 card-cont">
              <div class="card override-card border-0">
                <img class="img-card-full" [src]="service.img" alt="Banner service" />
                <div class="content-card-overlay">
                  <div class="col-12 px-3 py-2">
                    <h3 class="text-white text-start mb-2">
                      <b>{{ service.title }}</b>
                    </h3>
                    <p class="text-white mb-0" style="text-align: start; font-size: 13px; line-height: 1.4;">
                      {{ service.content }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </div>
</div>
